<template>
  <select-with-buttons :options="options"
                       @click="propagateClick"></select-with-buttons>
</template>

<script>
import SelectWithButtons from '../lib/SelectWithButtons';
import {suitHtml} from '@/lib/cardSuits';

export default {
  name: 'SelectSuit',
  components: {SelectWithButtons},
  props: {
    showNt: {type: Boolean, default: false}
  },
  computed: {
    options() {
      const temp = [
        {value: 0, text: suitHtml.clubs, class: ['suit']},
        {value: 1, text: suitHtml.diams, class: ['suit']},
        {value: 2, text: suitHtml.hearts, class: ['suit']},
        {value: 3, text: suitHtml.spades, class: ['suit']},
      ];
      if (this.showNt) {
        temp.push({value: 4, text: suitHtml.nt});
      }
      return temp;
    }
  },
  methods: {
    propagateClick(clicked) {
      this.$emit('click', clicked);
    }
  }
};
</script>

<style scoped>

>>> .suit span{
  line-height: 2.3rem;
}
</style>
